import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter as Router, Redirect, Switch, Route, Link } from "react-router-dom";

import { App } from "./app";

function Health() {
    return (<div><h3>East or West, SWA is the best</h3></div>)
}

ReactDOM.render(
    <>
        {/* <App/> */}
        <Router>
            <Switch>
                <Route exact path="/health" component={Health}></Route>
                <Route exact path="/" component={App} />
            </Switch>
        </Router>
    </>,
    document.getElementById('root')
);
